module.exports = __webpack_public_path__ + "static/img/autoship_logo-2.ea8dd8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/autoship_logo-2.png
// module id = 262
// module chunks = 1